module.exports = __webpack_public_path__ + "static/media/nimes_tour.b80da9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_tour.png
// module id = 739
// module chunks = 0